// extracted by mini-css-extract-plugin
export default {"fab":"scan-fab_fab__ya3Bz","active":"scan-fab_active__USgfV","pulse":"scan-fab_pulse__gazf0","dragging":"scan-fab_dragging__gWAGG","tooltip":"scan-fab_tooltip__ZG73n"};